import isArray from 'lodash/isArray'
import { create } from 'zustand'

import { ChatActions, IChat } from '../src/utils/interface'

const chatReducer = (
  state: IChat,
  action: ChatActions | ChatActions[]
): IChat => {
  if (isArray(action)) {
    let tempState = state.conversation
    let loading = state.loading
    action.forEach((value) => {
      switch (value.type) {
        case 'setLoading':
          loading = value.payload
          return loading
        case 'pop':
          return tempState.pop()
        case 'shift':
          return tempState.shift()
        case 'clearChat':
          return (tempState = [])
        case 'unShift':
          return tempState.unshift(value.payload)
        default:
          return tempState.push(value.payload)
      }
    })
    return { ...state, conversation: [...tempState], loading }
  } else {
    switch (action.type) {
      case 'setLoading':
        return { ...state, loading: action.payload }
      case 'pop':
        state.conversation.pop()
        return { ...state, conversation: state.conversation }
      case 'shift':
        state.conversation.shift()
        return { ...state, conversation: state.conversation }
      case 'clearChat':
        return { ...state, conversation: [] }
      case 'push':
        return {
          ...state,
          conversation: [...state.conversation, action.payload],
        }
      case 'unShift':
        state.conversation.unshift(action.payload)
        return {
          ...state,
          conversation: [...state.conversation],
        }
      default:
        return state
    }
  }
}

const useChatStore = create<IChat>((set) => ({
  conversation: [],
  loading: false,
  setConversation: (payload) => {
    set((state) => chatReducer(state, payload))
  },
}))

export { useChatStore }
